import DottedTexture from '@/assets/branding/dotted-texture.svg?react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';
import { ScrollArea } from '@/components/ui/scroll-area';
import { PropTradingTermsOfService } from '@/markdown/components';
import { DialogProps } from '@radix-ui/react-dialog';
import { useEffect, useState } from 'react';

interface Props extends DialogProps {
  onSubmit(): void;
}

export default function TermsOfServiceModal({ onSubmit, ...props }: Props) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    setIsScrolled(false);
  }, [props.open]);

  return (
    <Dialog {...props}>
      <DialogContent className="sm:max-w-3xl sm:rounded-3xl">
        <div className="relative overflow-hidden">
          <DottedTexture className="pointer-events-none absolute -top-24 z-[-1] h-auto w-full [&_ellipse]:fill-green" />
          <DialogHeader className="space-y-3 px-6 pb-5 pt-10 sm:px-10">
            <DialogTitle className="mx-auto max-w-96 text-center text-2xl/snug sm:text-3xl/snug lg:text-4xl/snug">
              VEST PROP TRADING
              <br />
              TERMS OF SERVICE
            </DialogTitle>
          </DialogHeader>
          <ScrollArea
            className="h-96 px-6 sm:px-10"
            onScroll={(e) => {
              if (isScrolled) return;
              const { scrollHeight, scrollTop, offsetHeight } = e.currentTarget;
              setIsScrolled(scrollTop >= scrollHeight - offsetHeight - 1);
            }}
          >
            <PropTradingTermsOfService />
          </ScrollArea>
          <DialogFooter className="px-6 pb-10 pt-5 max-sm:pb-28 sm:px-10">
            <Button
              disabled={!isScrolled}
              variant="foreground"
              className="w-full whitespace-normal"
              size="xl"
              onClick={onSubmit}
            >
              I have read and agree to the Terms Of Service
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
